const VideoPlayerEventEmitter = (jwplayer, options = {}) => {
  // options and variables
  const defaults = {
    position: 0,
    progressInterval: 15000,
    contentType: '',
    eventHandler: function () {}
  };
  const player = jwplayer;
  const settings = Object.assign({}, defaults, options);
  let playerIntervalId = null;

  const areCaptionsVisible = () => {
    const currentCaptionIndex = player.getCurrentCaptions();
    const currentCaption = player.getCaptionsList()[currentCaptionIndex];
    const isCurrentCaptionOff = currentCaption.id === 'off';
    return !isCurrentCaptionOff;
  };

  const generateInteractionPayload = (data) => {
    const { action, contentType, ...additionalData } = data;
    /* eslint-disable camelcase */
    const interaction = {
      action,
      content_type: contentType,
      position: Math.round(player.getPosition()),
      muted: player.getMute(),
      playback_rate: player.getPlaybackRate(),
      player_captions_visible: areCaptionsVisible(),
      player_fullscreen: player.getFullscreen(),
      player_visible: !!player.getViewable(),
      video_vertical_resolution: player.getHeight(),
      volume: player.getVolume()
    };
    /* eslint-enable camelcase */

    return { ...interaction, ...additionalData };
  };

  const playerEvent = (action, e) => {
    const message =
      !!e && !!e.message && !!e.code
        ? `JWPlayer Error ${e.code}: ${e.message}`
        : '';
    const interaction = generateInteractionPayload({
      action,
      message,
      contentType: settings.contentType
    });

    if (typeof settings.eventHandler === 'function') {
      // settings.eventHandler.call(this, interaction);
      Reflect.apply(settings.eventHandler, null, [interaction]);
    }
  };

  const progressEvent = () => {
    if (player.getState() !== 'playing') {
      return;
    }
    playerEvent('progress', null);
  };

  const initialize = () => {
    player.once('firstFrame', () => {
      player.seek(settings.position);

      player.on('play', (event) => playerEvent('play', event));
      player.on('pause', (event) => playerEvent('pause', event));
      player.on('idle', (event) => playerEvent('stop', event));
      player.on('seek', (event) => playerEvent('scroll', event));
      player.on('error', (event) => playerEvent('error', event));
      playerIntervalId = setInterval(progressEvent, settings.progressInterval);
    });
    player.on('viewable', (event) => {
      if (event.viewable !== 1) {
        return;
      }
      playerEvent('view', event);
    });
  };

  const destroy = () => {
    player.off('play');
    player.off('pause');
    player.off('idle');
    player.off('seek');
    player.off('error');
    player.off('viewable');
    clearInterval(playerIntervalId);
  };

  return {
    initialize,
    destroy
  };
};

export default VideoPlayerEventEmitter;
